(function () {
  var activeController = null;

  function noun(total, kind) {
    if (kind === "prenda") return total === 1 ? "prenda" : "prendas";
    return total === 1 ? "resultado" : "resultados";
  }

  function cacheKey() {
    var params = new URLSearchParams(window.location.search);
    params.delete("page");
    params.delete("view");
    params.delete("section_id");
    params.sort();
    return "amigui-search-count:" + window.location.pathname + "?" + params.toString();
  }

  function writeTotal(total, approximate) {
    document.querySelectorAll("[data-amigui-search-total]").forEach(function (node) {
      node.textContent = approximate ? String(total) + "+" : String(total);
      node.setAttribute("data-amigui-search-mode", "done");
    });
    document.querySelectorAll("[data-amigui-search-noun]").forEach(function (node) {
      node.textContent = noun(total, node.getAttribute("data-amigui-search-noun"));
    });
  }

  function visibleCards() {
    var grid = document.querySelector("[data-amigui-product-grid]");
    if (!grid) return 0;
    return grid.querySelectorAll(".amigui-card, .product-card, .card-product").length;
  }

  function countUrl(page) {
    var params = new URLSearchParams(window.location.search);
    params.delete("section_id");
    params.set("view", "amigui-count");
    params.set("page", String(page));
    return window.location.pathname + "?" + params.toString();
  }

  function readPayload(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var node = doc.getElementById("amigui-search-count");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "");
    } catch (error) {
      return null;
    }
  }

  function fetchPage(page, controller, attempt) {
    return fetch(countUrl(page), {
      credentials: "same-origin",
      signal: controller.signal,
      headers: { "X-Requested-With": "XMLHttpRequest" },
    }).then(function (response) {
      if (response.status === 429 && attempt < 3) {
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 2000);
        }).then(function () {
          return fetchPage(page, controller, attempt + 1);
        });
      }
      if (!response.ok) throw new Error("count request failed");
      return response.text().then(readPayload);
    });
  }

  function countAll() {
    var targets = document.querySelectorAll('[data-amigui-search-total][data-amigui-search-mode="remote"]');
    if (!targets.length) return;

    var key = cacheKey();
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(key) || "null");
      if (cached && cached.expires > Date.now() && Number.isFinite(cached.total)) {
        writeTotal(cached.total, false);
        return;
      }
    } catch (error) {
      cached = null;
    }

    if (activeController) activeController.abort();
    var controller = new AbortController();
    activeController = controller;
    targets.forEach(function (node) {
      node.setAttribute("data-amigui-search-mode", "counting");
    });

    fetchPage(1, controller, 0)
      .then(function (first) {
        if (!first || !Number.isFinite(first.pages) || !Number.isFinite(first.count)) {
          throw new Error("invalid count payload");
        }
        var total = first.count;
        var pages = Math.max(1, first.pages);
        var pending = [];
        for (var page = 2; page <= pages; page += 1) pending.push(page);

        function nextPair() {
          if (!pending.length) return Promise.resolve(total);
          var batch = pending.splice(0, 2);
          return Promise.all(batch.map(function (page) {
            return fetchPage(page, controller, 0);
          })).then(function (payloads) {
            payloads.forEach(function (payload) {
              if (!payload || !Number.isFinite(payload.count)) throw new Error("invalid count page");
              total += payload.count;
            });
            return nextPair();
          });
        }

        return nextPair();
      })
      .then(function (total) {
        if (controller !== activeController) return;
        writeTotal(total, false);
        try {
          window.sessionStorage.setItem(key, JSON.stringify({
            total: total,
            expires: Date.now() + 10 * 60 * 1000,
          }));
        } catch (error) {
          return;
        }
      })
      .catch(function (error) {
        if (!error || error.name === "AbortError" || controller !== activeController) return;
        var shown = visibleCards();
        writeTotal(shown, true);
      });
  }

  function boot() {
    window.requestAnimationFrame(countAll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  var observerTimer = 0;
  var observer = new MutationObserver(function () {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(function () {
      if (document.querySelector('[data-amigui-search-total][data-amigui-search-mode="remote"]')) boot();
    }, 150);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
